<div
    #cardContainer
    [id]="id"
    class="agpr-postFeed agpr-contextMenu-parent"
    [attr.data-mention-id]="mention.mentionId"
    [attr.data-mercury-id]="mention.id"
    (agprClickUnless)="openPostViewer()"
    [agprClickUnlessSelectors]="['agpr-checkbox', 'a']"
>
    <div
        class="agpr-postFeed-main"
    >
        <div
            [id]="id + '_feedContent'"
            class="agpr-postFeed-mainInfo"
        >
            @if (tweetType === tweetTypeEnum.RETWEET || linkedinType === linkedinTypeEnum.REPOST) {
                <div class="agpr-postFeed-mainInfo-retweet">
                    <span class="agpr-postFeed-mainInfo-retweetIcon fa-regular fa-duotone fa-arrows-retweet"></span>
                    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                    <div
                        class="agpr-postFeed-mainInfo-retweetHandle"
                        (click)="$event?.stopPropagation()"
                    >
                        <div
                            class="agpr-postFeed-link"
                            [innerHTML]="mention?.handle ? mention?.handle : '@' + mention?.author?.name | mentionLinks:mention.mediaType.id"
                        >
                        </div>
                    </div>
                    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                    <span>{{ 'Mention.Reposted' | localize }}</span>
                </div>
            }

            <div class="agpr-postFeed-mainInfo-topRow">
                <div class="agpr-postFeed-mainInfo-avatar">
                    <!-- For retweet scenario, here we use placeholder for now, as b.e has difficulty in getting original tweet avatar -->
                    <a
                        *ngIf="tweetType !== tweetTypeEnum.RETWEET && mention?.socialAvatarUrl"
                        [attr.aria-label]="'Social.postFeed.profileImage' | localize"
                        class="agpr-postFeed-mainInfo-avatar-img"
                        target="_blank"
                        [href]="mention.socialUrl"
                    >
                        <img
                            [agprImageSrc]="mention?.socialAvatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                            alt=""
                            [agprDefaultImage]="imageDefault[mediaType]"
                            (agprFailedToFetchImage)="mention.socialAvatarUrl = null;"
                        />
                    </a>

                    <a
                        *ngIf="!mention.socialAvatarUrl || tweetType === tweetTypeEnum.RETWEET"
                        class="agpr-postFeed-mainInfo-avatarPlaceholder"
                        [style.background-color]="socialNetworkTypeColorMap[mention?.mediaType.id]"
                        [attr.aria-label]="'Social.postFeed.profileImage' | localize"
                        target="_blank"
                        [href]="mention.socialUrl"
                    >
                        <span>{{ mention?.avatarPlaceholderText }}</span>
                    </a>
                </div>
                <div class="agpr-postFeed-mainInfo-titleContainer">
                    <div class="agpr-postFeed-mainInfo-authorContainer">
                        <div class="agpr-postFeed-mainInfo-authorName">
                            @if (
                                tweetType !== tweetTypeEnum.RETWEET &&
                                !mention?.subreddit &&
                                mediaType !== mediaTypes.YOUTUBE &&
                                linkedinType !== linkedinTypeEnum.REPOST
                            ) {
                                {{ mention?.username ? mention?.username : mention?.author?.name ? mention.author.name : (mention.mediaType.noHeadlineMessage | localize) }}
                            }

                            @if (mediaType === mediaTypes.YOUTUBE) {
                                <a
                                    *ngIf="mention?.socialUrl"
                                    [href]="mention?.socialUrl"
                                    target="_blank"
                                    (click)="$event?.stopPropagation()"
                                >
                                    {{ mention?.username ? mention?.username : mention?.author?.name ? mention.author.name : (mention.mediaType.noHeadlineMessage | localize)}}
                                </a>
                                <span *ngIf="!mention?.socialUrl">
                                    {{ mention?.username ? mention?.username : mention?.author?.name ? mention.author.name : (mention.mediaType.noHeadlineMessage | localize)}}
                                </span>
                            }

                            @if (tweetType === tweetTypeEnum.RETWEET) {
                                {{ mention?.tweetData?.originalTweetData?.originalUserName ? mention?.tweetData?.originalTweetData?.originalUserName : (mention.mediaType.noHeadlineMessage | localize) }}
                            }

                            @if (linkedinType === linkedinTypeEnum.REPOST) {
                                {{ mention?.linkedinData?.originalActivityData?.originalUserName ? mention?.linkedinData?.originalActivityData?.originalUserName : (mention.mediaType.noHeadlineMessage | localize) }}
                            }

                            @if (mention?.subreddit) {
                                <a
                                    [href]="mention?.socialUrl"
                                    target="_blank"
                                    (click)="$event?.stopPropagation()"
                                >
                                    {{ mention?.subreddit ? mention?.subreddit : (mention.mediaType.noHeadlineMessage | localize) }}
                                </a>
                            }
                        </div>
                        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                        <div
                            class="agpr-postFeed-mainInfo-handle"
                            (click)="$event?.stopPropagation()"
                        >
                            @if (mention?.tweetData?.originalTweetData?.originalUserHandle || mention?.handle) {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="(tweetType === tweetTypeEnum.RETWEET ? mention?.tweetData?.originalTweetData?.originalUserHandle : mention?.handle) | mentionLinks:mention.mediaType.id"
                                >
                                </div>
                            }
                            @if (mention?.linkedinData?.originalActivityData?.originalUserHandle || mention?.handle) {
                                <div
                                    class="agpr-postFeed-link"
                                    [innerHTML]="(linkedinType === linkedinTypeEnum.REPOST ? mention?.linkedinData?.originalActivityData?.originalUserHandle : mention?.handle) | mentionLinks:mention.mediaType.id"
                                >
                                </div>

                            }
                        </div>
                        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                    </div>
                    <div
                        *ngIf="mention?.musicTitle"
                        class="agpr-postFeed-mainInfo-musicContainer"
                    >
                        <span class="fa-solid fa-music agpr-postFeed-mainInfo-musicContainer-icon"></span>
                        <a
                            class="agpr-postFeed-mainInfo-musicContainer-link"
                            [href]="mention?.musicUrl"
                            target="_blank"
                            (click)="$event?.stopPropagation()"
                        >
                            {{ mention?.musicTitle }}
                        </a>
                    </div>
                </div>
                <div class="agpr-postFeed-mainInfo-iconAndTime">
                    <img
                        *ngIf="mention?.mediaType?.socialIconImageUrl"
                        [src]="appBaseHref + mention.mediaType.socialIconImageUrl"
                        [alt]="('MediaType.' + mediaType) | localize"
                        tooltipPosition='top'
                        [agprTooltip]="('MediaType.' + mediaType) | localize"
                    />
                </div>
            </div>
            @if (mention?.musicTitle) {
                <div class="agpr-postFeed-mainInfo-musicContainer">
                    <span class="fa-solid fa-music agpr-postFeed-mainInfo-musicContainer-icon"></span>
                    <a
                        class="agpr-postFeed-mainInfo-musicContainer-link"
                        [href]="mention?.musicUrl"
                        target="_blank"
                        (click)="$event?.stopPropagation()"
                    >
                        {{ mention?.musicTitle }}
                    </a>
                </div>
            }
            <div
                #mainBody
                class="agpr-postFeed-mainInfo-body"
                [ngClass]="{ 'agpr-postFeed-mainInfo-body-unexpanded': !contentVisible }"
            >
                @if (tweetType === tweetTypeEnum.REPLY && mention?.tweetData?.originalTweetData?.originalUserHandle) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.tweetData?.originalTweetData?.originalUserHandle) | mentionLinks:mention.mediaType.id"
                    ></span>
                } @else if (tweetType === tweetTypeEnum.REPLY && mention?.tweetData?.originalTweetData?.originalUserName) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.tweetData?.originalTweetData?.originalUserName) | mentionLinks:mention.mediaType.id"
                    ></span>
                } @else if (blueskyType === blueskyTypeEnum.REPLY && mention?.blueskyData?.originalPostData?.originalUserHandle) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.blueskyData?.originalPostData?.originalUserHandle) | mentionLinks:mention.mediaType.id"
                    ></span>
                } @else if (blueskyType === blueskyTypeEnum.REPLY && mention?.blueskyData?.originalPostData?.originalUserName) {
                    <span
                        class="agpr-postFeed-mainInfo-body-replyLine"
                        [innerHTML]="(('Social.postFeed.replyingTo' | localize) + '@' + mention?.blueskyData?.originalPostData?.originalUserName) | mentionLinks:mention.mediaType.id"
                    ></span>
                }

                <div>
                    <span
                        [ngClass]="{'agpr-postFeed-mainInfo-body-headline': mention.body}"
                    >
                        {{ mention.headline }}
                    </span>
                    <span>{{ mention.body }}</span>
                </div>
            </div>
            <div
                class="agpr-postFeed-mainInfo-images"
                *ngIf="contentVisible"
            >
                <div
                    *ngFor="let image of mention.images;"
                    class="agpr-postFeed-mainInfo-mediaWrapper"
                >
                    <img
                        *ngIf="!image.error"
                        class="agpr-postFeed-mainInfo-media"
                        [src]="image.source"
                        [alt]="'Social.postFeed.mentionImage.alt' | localize"
                        (error)="image.error = true"
                    />
                </div>
                <div
                    *ngIf="embedVideoUrl"
                    class="agpr-postFeed-mainInfo-mediaWrapper"
                >
                    <iframe
                        [src]="embedVideoUrl | agprBypassURLSecurity"
                        class="agpr-postFeed-mainInfo-media"
                        width="100%"
                        height="420"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        [title]="iframeTitle"
                    >
                    </iframe>
                </div>
            </div>

            @if (
                mediaType === mediaTypes.TWITTER ||
                mediaType === mediaTypes.LINKEDIN ||
                mediaType === mediaTypes.BLUESKY
            ) {
                <div class="agpr-postFeed-mainInfo-engagement">
                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.likes' | localize) + (mention?.like || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-heart"></span>
                        <span>{{ mention?.like || 'N/A' }}</span>
                    </div>
                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.Replies' | localize) + (mention?.reply || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-comment"></span>
                        <span>{{ mention?.reply || 'N/A' }}</span>
                    </div>
                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.retweets' | localize) + (mention?.share || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-arrows-retweet"></span>
                        <span>{{ mention?.share || 'N/A' }}</span>
                    </div>
                </div>
            }


            @if (
                mediaType === mediaTypes.FACEBOOK ||
                mediaType === mediaTypes.INSTAGRAM ||
                mediaType === mediaTypes.YOUTUBE ||
                mediaType === mediaTypes.TIKTOK
            ) {
                <div class="agpr-postFeed-mainInfo-engagement">
                    @if (mediaType === mediaTypes.YOUTUBE || mediaType === mediaTypes.TIKTOK) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.views' | localize) + (mention?.view || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-eye"></span>
                            <span>{{ mention?.view || 'N/A' }}</span>
                        </div>
                    }

                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.likes' | localize) + (mention?.like || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-thumbs-up"></span>
                        <span>{{ mention?.like || 'N/A' }}</span>
                    </div>

                    <div
                        class="agpr-postFeed-mainInfo-engagementWrapper"
                        [agprTooltip]="('Social.postFeed.comments' | localize) + (mention?.reply || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                            + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                        tooltipPosition='top'
                    >
                        <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-comment"></span>
                        <span>{{ mention?.reply || 'N/A' }}</span>
                    </div>

                    @if (mediaType === mediaTypes.FACEBOOK || mediaType === mediaTypes.TIKTOK) {
                        <div
                            class="agpr-postFeed-mainInfo-engagementWrapper"
                            [agprTooltip]="('Social.postFeed.shares' | localize) + (mention?.share || 'N/A') + '\n' + ('Social.postFeed.lastUpdate' | localize)
                                + (mention?.engagementLastFetchedDate ? (mention?.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
                            tooltipPosition='top'
                        >
                            <span class="agpr-postFeed-mainInfo-engagement-icon fa-regular fa-duotone fa-circle-nodes"></span>
                            <span>{{ mention?.share || 'N/A' }}</span>
                        </div>
                    }
                </div>
            }

        </div>
    </div>
    <div class="agpr-postFeed-additionalInfo">
        <div class="agpr-postFeed-additionalInfo-topRow">
            <div
                class="agpr-postFeed-additionalInfo-badgeWrapper"
            >
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                    *ngIf="mention.images?.length > 0"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-image"
                        agprTooltip="Social.postFeed.badge.image"
                        tooltipPosition='top'
                    ></span>
                </div>
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                    *ngIf="embedVideoUrl"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-film"
                        agprTooltip="Social.postFeed.badge.video"
                        tooltipPosition='top'
                    ></span>
                </div>
            </div>
            <div
                class="agpr-postFeed-additionalInfo-badgeWrapper"
                *ngIf="mention.createdByUserId || mention.createdDate"
            >
                <div
                    class="agpr-postFeed-additionalInfo-badge"
                >
                    <span
                        role="img"
                        class="fa-regular fa-duotone fa-floppy-disk"
                        agprTooltip="Social.postFeed.badge.savedPost"
                        tooltipPosition='top'
                    ></span>
                </div>
            </div>
        </div>
        <div class="agpr-postFeed-additionalInfo-bottomRow">
            <div class="agpr-postFeed-additionalInfo-wrapperContinued">
                <div *ngIf="preferences">
                    <span class="agpr-postFeed-metadataLabel">
                        {{ 'Social.postFeed.published' | localize}}
                    </span>
                    <span
                        class="agpr-postFeed-metadataValue"
                        [pTooltip]="('Social.postFeed.datePublished' | localize) + (mention?.datePublished | changeTimeZone: preferences.timeZone: dateFormat) +
                            '\n' + ('Social.postFeed.dateAvailable' | localize) + (mention?.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat)"
                        tooltipPosition='top'
                    >
                        {{ mention.datePublished | changeTimeZone: preferences.timeZone: dateFormat }}
                    </span>
                </div>
                <div>
                    <span class="agpr-postFeed-metadataLabel">
                        {{ 'Social.postFeed.sentiment' | localize }}
                    </span>
                    <span class="agpr-postFeed-metadataValue">
                        {{ mention.sentimentName | localize }}
                    </span>
                </div>
                <div>
                    <span class="agpr-postFeed-metadataLabel">
                        {{ impressionLabel | localize }}
                    </span>
                    <span class="agpr-postFeed-metadataValue agpr-postFeed-metadataValueLast">
                        {{ (mention.audienceReach !== undefined && mention.audienceReach !== null) ? (mention.audienceReach | number) : ('na' | localize) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    @if (!preview) {
        <div
            class="agpr-contextMenu bottom right"
            [agprTooltip]="mention.translating ? ('Mention.translating' | localize) : ''"
            [agprLoading]="mention.translating"
            [loadingSmallIndicator]="mention.translating"
        >
            <agpr-button
                [icon]="'fa-regular fa-duotone fa-eye'"
                (click)="openPostViewer()"
                [style]="buttonTypes.contextMenu"
                tooltip="Social.post.viewer.viewPostInformation"
            ></agpr-button>
        </div>
    }
</div>
